import { render, staticRenderFns } from "./farm-index.vue?vue&type=template&id=37d57cb4&scoped=true&"
import script from "./farm-index.vue?vue&type=script&lang=js&"
export * from "./farm-index.vue?vue&type=script&lang=js&"
import style0 from "./farm-index.vue?vue&type=style&index=0&id=37d57cb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d57cb4",
  null
  
)

export default component.exports